/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { EnrollCourseOptions, EnrollCourseResponses } from '../../models/EnrollCourse'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @summary Enroll Course
 * {@link /course/:course_id/enroll}
 */
export function enrollCourse<ThrowOnError extends boolean = true>(options: Options<EnrollCourseOptions, ThrowOnError>): Promise<UnwrappedResult<EnrollCourseResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'POST', url: '/course/{course_id}/enroll', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<EnrollCourseResponses, ThrowOnError>>
}
